import { Warning } from "@phosphor-icons/react";
import { Component, type ReactNode } from "react";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface ErrorBoundaryProps {
  children?: ReactNode;
}

export class PredictionOutputErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-full border border-r8-red-6 bg-r8-red-a2 flex flex-col p-6 mt-2">
          <div className="flex items-center justify-center">
            <Warning size={24} className="text-r8-red-10" />
          </div>
          <div className="space-y-2">
            <p className="mt-4 text-r8-red-11">
              An error occurred while rendering the output preview.
            </p>
            <div className="bg-r8-red-1 min-h-24 max-h-64 overflow-auto p-4 text-r8-xs font-mono text-r8-red-11 border border-r8-red-3">
              <p>
                {this.state.error?.message || "An unknown error has occurred"}
              </p>
              {this.state.error?.stack ? (
                <p className="mt-2">{this.state.error?.stack}</p>
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    return this.props?.children;
  }
}
